export const OpenOriginalTCCardMessage = 'Для дальнейшей работы с ответом на'
    + ' требование можете перейти в карточку транспортного контейнера';

export const OpenOriginalTCCardTitle = 'Ответ успешно сформирован';
